import React from 'react';
import { StepsProvider } from 'react-step-builder';

export default function MultiStepProvider({ children }) {
  return <StepsProvider>{children}</StepsProvider>;
}
